export default {"src":"/_next/static/media/lsm-tutorial-unqualified.2bbff324.svg","height":165,"width":165,"blurWidth":0,"blurHeight":0};